import React, { createContext, useContext, useState } from 'react';
import { translations } from '@/i18n/translations';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(localStorage.getItem('ae_lang') || 'es');

  const t = (key) => {
    return translations[language]?.[key] || translations['es']?.[key] || key;
  };

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('ae_lang', lang);
  };

  const toggleLanguage = () => {
    const next = language === 'es' ? 'en' : 'es';
    changeLanguage(next);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: changeLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
